import { render, staticRenderFns } from "./FlipCardListElementSettings.vue?vue&type=template&id=2f0f663d&scoped=true&"
import script from "./FlipCardListElementSettings.vue?vue&type=script&lang=ts&"
export * from "./FlipCardListElementSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0f663d",
  null
  
)

export default component.exports